import React from 'react';
import PropTypes from 'prop-types';

import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { makeSelectSelectedParams } from '../CatalogSearch/selectors';
import { updateParam } from '../CatalogSearch/actions';

import './styles.scss';
import { getObjByAttribute } from '../../utils/common';

class SelectCollapsible extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
    };
  }

  handeOnClick = (value, valueName) => {
    const valueLabel = valueName && valueName.length ? valueName : value;

    this.props.updateValue({
      name: this.props.name,
      value,
      label: this.props.label,
      valueLabel
    });
  };

  handleOnShow = e => {
    this.setState(prevState => ({
      show: !prevState.show,
    }));
  };

  render() {
    const { label, name, options, unit, selectedParams, className } = this.props;
    const { show } = this.state;
    const current = getObjByAttribute(selectedParams, 'name', name);
    return (
      <div className={`SelectCollapsible ${className}`}>
        <h4 className="todo-sidebar-section-header" onClick={this.handleOnShow}>
          {label}
          <span style={{ float: 'right' }}>
            {show ? (
              <i className="os-icon os-icon-arrow-up4" />
            ) : (
              <i className="os-icon os-icon-arrow-down3" />
            )}
          </span>
        </h4>
        {show && (
          <div className="todo-sidebar-section-contents">
            {options.map((item, key) => (
              <div
                className={
                  current !== null &&
                  current.hasOwnProperty('value') &&
                  current.value === item.value
                    ? 'chip active'
                    : 'chip'
                }
                key={key}
                onClick={() => this.handeOnClick(item.value, item.name)}
              >
                {' '}
                {unit.length > 0 && `${unit} `}
                {item.label}{' '}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

SelectCollapsible.defaultProps = {
  unit: '',
  className: '',
  show: false,
};
SelectCollapsible.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  unit: PropTypes.string,
  className: PropTypes.string,
  selectedParams: PropTypes.array,
  show: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  selectedParams: makeSelectSelectedParams(),
});
export function mapDispatchToProps(dispatch) {
  return {
    updateValue: values => dispatch(updateParam(values)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
)(SelectCollapsible);

